import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';
import Modal from 'react-modal';
import { JoykitIcon } from '@components/JoykitIcon';

const PAGE_MAX_WIDTH = '1200px';
const BANNER_HEIGHT = {
  belowSm: '528px',
  default: '410px',
};
const MODAL = {
  maxHeight: '768px',
  width: '640px',
};
const CONTENT_MAX_WIDTH = '420px';
const TITLE_MAX_WIDTH = {
  default: '260px',
  xl: '300px',
};

export const StyledSection = styled(Flex)`
  padding: ${themeSpace(8)} ${themeSpace(7)};
  width: 100%;
  ${themeMediaQuery('md')} {
    padding: ${themeSpace(8)} ${themeSpace(12)};
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding: ${themeSpace(8)} 0;
  }
`;

export const StyledContainer = styled(Flex)`
  position: relative;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: ${themeSpace(5)};
  height: ${BANNER_HEIGHT.default};
  width: 100%;
  padding-right: 28rem;
  overflow: hidden;
  ${themeMediaQuery('below_sm')} {
    height: ${BANNER_HEIGHT.belowSm};
    align-items: flex-start;
    padding: ${themeSpace(5)} ${themeSpace(4)} 0;
  }
`;
export const StyledContentWrapper = styled(Flex)`
  z-index: 2;
  max-width: ${CONTENT_MAX_WIDTH};
  flex-direction: column;
  align-items: center;
`;

export const StyledTextPairing = styled(TextPairing)`
  text-align: center;
  align-items: center;
  .text-pairing-title {
    max-width: ${TITLE_MAX_WIDTH.default};
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: ${TITLE_MAX_WIDTH.xl};
    }
  }
`;

export const StyledButton = styled(Button)`
  margin-top: ${themeSpace(6)};
  width: fit-content;
  border-radius: ${themeSpace(6)};
  color: ${(props) => props.theme.colors.mono1};
  &:hover {
    background-color: ${themeColor('neutra5')};
  }
  &:active {
    background-color: ${themeColor('neutra6')};
  }
`;

export const StyledBox = styled(Box)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: lightgray 50%;
`;

export const StyledModal = styled(Modal)``;

export const StyledVideoContainer = styled(Box)`
  background-color: ${themeColor('white')};
  width: ${MODAL.width};
  height: 100%;
  max-height: ${MODAL.maxHeight};
  border-radius: ${themeSpace(5)};
  overflow: hidden;
  margin: ${themeSpace(8)} ${themeSpace(6)} ${themeSpace(11)};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 100%;
    max-height: none;
    padding: ${themeSpace(6)};
    margin: 0;
    border-radius: 0;
  }
`;

export const StyledCloseButtonWrapper = styled(Box)`
  position: relative;
  height: ${themeSpace(9)};
`;

export const StyledCloseButton = styled(Button)`
  position: absolute;
  top: ${themeSpace(1)};
  right: ${themeSpace(1)};
  padding: ${themeSpace(3)};
  background: none;
  border: none;
  width: ${themeSpace(10)};
  height: ${themeSpace(10)};
  display: flex;
  align-items: center;
  justify-content: center;
  :focus {
    outline: none;
  }
  ${themeMediaQuery('below_sm')} {
    top: ${themeSpace(1)};
    right: ${themeSpace(1)};
  }
`;

export const StyledCloseIcon = styled(JoykitIcon)`
  width: ${themeSpace(5)};
  height: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    width: ${themeSpace(4)};
    height: ${themeSpace(4)};
  }
`;
